import { createGlobalStyle, css } from 'styled-components'
import '../assets/fonts/index.css'

const rootColors = {
  default: css`
    :root {
      --primary: #36215A;
      --secondary: #ECD700;

      --text-secondary: #1D1D1D;

      --black: #000;
      --danger: #dc3545;
      --white: #fff;
    }
  `
}

const GlobalStyle = createGlobalStyle`
  ${rootColors.default}

  * {
    box-sizing: border-box;
    font-family: Ubuntu;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: var(--white);
  }

  #root {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
  }

  main {
    flex: 1;
  }

  button {
    align-items: center;
    background-color: var(--secondary);
    border: none;
    border-radius: 40px;
    color: var(--primary);
    cursor: pointer;
    display: flex;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    padding: 10px 32px 10px 32px;
    transition: ease-in 1000ms;
    white-space: nowrap;
    width: fit-content;

    &:hover {
      box-shadow: 0 0 20px 0 rgba(236, 215, 0, .72);
    }

    @media (max-width: 764px) {
      font-size: 16px;
      line-height: 24px;
      padding: 8px 32px;
    }
  }

  h1, h2, h3, h4, h5, h6,
  p, span, a, button {
    color: var(--primary);
  }

  a {
    text-decoration: none;
  }

  figure {
    line-height: 0;
    max-width: fit-content;

    img {
      width: 100%;
    }
  }
`

export default GlobalStyle
